module.exports = __webpack_public_path__ + "img/login-left.254ec321.jpg";